import request from './core/request'

// 商品相关API
export default {
	//获取商品分类
	getGoodsCategoryList: (expertId) => request.get(`/mobile/getGoodsCategoryList/${expertId}`),
	//获取商品品牌
	getGoodsBrandList: (data) => request.post(`/mobile/getGoodsBrandList`, data),
	//获取商品列表
	getGoodsList: (params) => request.get(`/mobile/getGoodsList`, params),
	//获取商品品质列表
	getGoodsTagList: (params) => request.post(`/mobile/getGoodsTagList`, params),
  // 获取首页菜单配置信息
  getHomeConfig: () => request.get(`/mobile/getHomeConfig`),
	//获取商品列表（根据上传图片搜索）/ 以图搜图 - 商品套装
	getGoodsByImage: (data, isSuit = false) => request.post(`/goods-image/${isSuit ? 'search-by-image-suit' : 'search-by-image'}`, data),
	//根据达人ID分页查询商品套装列表
	getGoodsSuitList: (params) => request.get('/mobile/getGoodsSuitList', params),
	// 商品点击统计
	addGoodsClick: (data) => request.post('/mobile/addGoodsClick', data),
}